
import { OC_PLUS_MODAL_TRIGGER } from '@marketplace/config/ocplus.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    props: {
        index: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        isNew: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        openModal(index) {
            this.$emit('clicked')

            switch (index) {
                case '1':
                    this.whyUseOcOpenModal()
                    trackClick(
                        'Why use OrderChamp modal clicked',
                        { category: 'Header' },
                        ''
                    )
                    break
                case '2':
                    this.paymentMethodsOpenModal()
                    trackClick(
                        'Payment methods modal clicked',
                        { category: 'Header' },
                        ''
                    )
                    break
                case '3':
                    this.orderProcessOpenModal()
                    trackClick(
                        'Order process modal clicked',
                        { category: 'Header' },
                        ''
                    )
                    break
                case '4':
                    this.howOcPlusWorkOpenModal()
                    trackClick(
                        'How Orderchamp plus work modal clicked',
                        { category: 'Header' },
                        ''
                    )
                    break
                default:
                    console.error('Invalid index')
            }
        },
        whyUseOcOpenModal() {
            EventBus.$emit('modal-open', 'modal-why-use-OC', {
                closeButtonText: this.$t('labels.skip'),
            })
        },
        paymentMethodsOpenModal() {
            EventBus.$emit('modal-open', 'modal-payment-methods', {
                closeButtonText: this.$t('labels.skip'),
            })
        },
        orderProcessOpenModal() {
            EventBus.$emit('modal-open', 'modal-order-process', {
                closeButtonText: this.$t('labels.skip'),
            })
        },
        howOcPlusWorkOpenModal() {
            EventBus.$emit(OC_PLUS_MODAL_TRIGGER)
        },
    },
}
